import React from 'react'
import styled from 'styled-components'

const Container = styled.div`
  margin-left: 40px;
`

const FooterTitle = ({ title }: { title: string }) => <Container>{title}</Container>

export default FooterTitle
